import React from "react";
import Slider from "react-slick";
import mouthImage from "./images/Mouth/Original(2).png";
import mouthImage2 from "./images/Mouth/Rabbitteeth.png";
import mouthImage3 from "./images/Mouth/glas.png";
import bodyImage from "./images/Body/Originalbody.png";
import bodyImage2 from "./images/Body/Neon.png";
import bodyImage3 from "./images/Body/beer.png";
import bodyImage4 from "./images/Body/grasss.png";
import bodyImage5 from "./images/Body/green.png";
import bodyImage6 from "./images/Body/red.png";
import bodyImage7 from "./images/Body/stars.png";
import bodyImage8 from "./images/Body/ye.png";
import hatsImage from "./images/Hats/Capss.png";
import hatsImage2 from "./images/Hats/Headband.png";
import hatsImage3 from "./images/Hats/moooney.png";
import hatsImage4 from "./images/Hats/,jh.png";
import hatsImage5 from "./images/Hats/pf.png";
import eyesImage from "./images/Eyes/Bigeyes.png";
import eyesImage2 from "./images/Eyes/Original(1).png";
import eyesImage3 from "./images/Eyes/sus.png";
import eyesImage4 from "./images/Eyes/smail.png";
import clothesImage from "./images/Clothes/Bipp.png";
import clothesImage2 from "./images/Clothes/Cape.png";
import clothesImage3 from "./images/Clothes/mhand.png";
import backgroundImage from "./images/Background/Bg1.png";
import backgroundImage2 from "./images/Background/Bg2.png";
import backgroundImage3 from "./images/Background/Bg3.png";
import backgroundImage4 from "./images/Background/Bg4.png";
import "./styles.css";

function SelectionPanel({ avatarParts, setAvatarParts }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };
  return (
    <div className="selectionPanel">
      {/* Buttons for Mouth */}
      <h1>Wizzie Meme Generator</h1>
      <div className={"section"}>
        <h3>Background</h3>
        <Slider {...settings}>
          <button
            className={`selectionbuttons ${
              avatarParts.Background === backgroundImage ? "selected" : ""
            }`}
            id="bg1"
            onClick={() =>
              setAvatarParts({ ...avatarParts, Background: backgroundImage })
            }
            style={{ width: "20px", height: "80px", margin: "0 10px" }}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Background === backgroundImage2 ? "selected" : ""
            }`}
            id="bg2"
            onClick={() =>
              setAvatarParts({ ...avatarParts, Background: backgroundImage2 })
            }
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Background === backgroundImage3 ? "selected" : ""
            }`}
            id="bg3"
            onClick={() =>
              setAvatarParts({ ...avatarParts, Background: backgroundImage3 })
            }
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Background === backgroundImage4 ? "selected" : ""
            }`}
            id="bg4"
            onClick={() =>
              setAvatarParts({ ...avatarParts, Background: backgroundImage4 })
            }
          ></button>
        </Slider>
      </div>
      <div className="section">
        <h3>Robes</h3>
        <Slider {...settings}>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage ? "selected" : ""
            }`}
            id="originalbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage2 ? "selected" : ""
            }`}
            id="neonbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage2 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage3 ? "selected" : ""
            }`}
            id="beerbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage3 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage4 ? "selected" : ""
            }`}
            id="grasssbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage4 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage5 ? "selected" : ""
            }`}
            id="greenbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage5 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage6 ? "selected" : ""
            }`}
            id="redbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage6 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage7 ? "selected" : ""
            }`}
            id="starsbody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage7 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Body === bodyImage8 ? "selected" : ""
            }`}
            id="yebody"
            onClick={() => setAvatarParts({ ...avatarParts, Body: bodyImage8 })}
          ></button>
        </Slider>
      </div>
      <div className="section">
        <h3>Left Hand</h3>
        <button
          class={`selectionbuttons ${
            avatarParts.Clothes === clothesImage ? "selected" : ""
          }`}
          id="bip"
          onClick={() =>
            setAvatarParts({ ...avatarParts, Clothes: clothesImage })
          }
        ></button>
        <button
          class={`selectionbuttons ${
            avatarParts.Clothes === clothesImage2 ? "selected" : ""
          }`}
          id="cape"
          onClick={() =>
            setAvatarParts({ ...avatarParts, Clothes: clothesImage2 })
          }
        ></button>
        <button
          class={`selectionbuttons ${
            avatarParts.Clothes === clothesImage3 ? "selected" : ""
          }`}
          id="mhand"
          onClick={() =>
            setAvatarParts({ ...avatarParts, Clothes: clothesImage3 })
          }
        ></button>
      </div>
      <div className="section">
        <h3>Facial</h3>
        <button
          id="originaleyes"
          class={`selectionbuttons ${
            avatarParts.Eyes === eyesImage2 ? "selected" : ""
          }`}
          onClick={() => setAvatarParts({ ...avatarParts, Eyes: eyesImage2 })}
        ></button>
        <button
          id="bigeyes"
          class={`selectionbuttons ${
            avatarParts.Eyes === eyesImage ? "selected" : ""
          }`}
          onClick={() => setAvatarParts({ ...avatarParts, Eyes: eyesImage })}
        ></button>
        <button
          id="sus"
          class={`selectionbuttons ${
            avatarParts.Eyes === eyesImage3 ? "selected" : ""
          }`}
          onClick={() => setAvatarParts({ ...avatarParts, Eyes: eyesImage3 })}
        ></button>
        <button
          id="smail"
          class={`selectionbuttons ${
            avatarParts.Eyes === eyesImage4 ? "selected" : ""
          }`}
          onClick={() => setAvatarParts({ ...avatarParts, Eyes: eyesImage4 })}
        ></button>
      </div>
      <div className="section">
        <h3>Right Hand</h3>
        <Slider {...settings}>
          <button
            class={`selectionbuttons ${
              avatarParts.Hats === hatsImage ? "selected" : ""
            }`}
            id="cap"
            onClick={() => setAvatarParts({ ...avatarParts, Hats: hatsImage })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Hats === hatsImage2 ? "selected" : ""
            }`}
            id="headband"
            onClick={() => setAvatarParts({ ...avatarParts, Hats: hatsImage2 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Hats === hatsImage3 ? "selected" : ""
            }`}
            id="mooney"
            onClick={() => setAvatarParts({ ...avatarParts, Hats: hatsImage3 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Hats === hatsImage4 ? "selected" : ""
            }`}
            id="bm"
            onClick={() => setAvatarParts({ ...avatarParts, Hats: hatsImage4 })}
          ></button>
          <button
            class={`selectionbuttons ${
              avatarParts.Hats === hatsImage5 ? "selected" : ""
            }`}
            id="pf"
            onClick={() => setAvatarParts({ ...avatarParts, Hats: hatsImage5 })}
          ></button>
        </Slider>
      </div>
      <div className="section">
        <h3>Accessories</h3>
        <button
          class={`selectionbuttons ${
            avatarParts.Mouth === mouthImage ? "selected" : ""
          }`}
          id="originalmouth"
          onClick={() => setAvatarParts({ ...avatarParts, Mouth: mouthImage })}
        ></button>
        <button
          class={`selectionbuttons ${
            avatarParts.Mouth === mouthImage2 ? "selected" : ""
          }`}
          id="rabbitmouth"
          onClick={() => setAvatarParts({ ...avatarParts, Mouth: mouthImage2 })}
        ></button>
        <button
          class={`selectionbuttons ${
            avatarParts.Mouth === mouthImage3 ? "selected" : ""
          }`}
          id="glas"
          onClick={() => setAvatarParts({ ...avatarParts, Mouth: mouthImage3 })}
        ></button>
      </div>
    </div>
  );
}
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "blue" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "blue" }}
      onClick={onClick}
    />
  );
}
export default SelectionPanel;
